import { t } from 'i18next';

import { ErrorResponseErrorItemCodeCommon } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeCommon, string> => ({
  'common:invalid_parameter_dependency': t('common.invalidParameterDependency', {
    ns: 'apiErrorCodes',
    sourcePath: '{sourcePath}',
    sourceValue: '{sourceValue}',
    requiredParamPath: '{requiredParamPath}',
    requiredExpectedValue: '{requiredExpectedValue}',
    defaultValue:
      'When parameter {sourcePath} has value {sourceValue} parameter {requiredParamPath} must have value {requiredExpectedValue}.',
  }),
  'common:no_leading_trailing_white_spaces': t('common.noLeadingTrailingWhiteSpaces', {
    ns: 'apiErrorCodes',
    defaultValue: 'Inledande och avslutande mellanslag är inte tillåtna.',
  }),
  'common:additional_properties_not_allowed': t('unexpectedError', { ns: 'common' }),
  'common:duplications_in_order_by': t('common.duplicationsInOrderBy', {
    ns: 'apiErrorCodes',
    defaultValue: 'Dubbletter ej tillåtna för sortering.',
  }),
  'common:missing_includes_in_order_by': t('common.missingIncludesInOrderBy', {
    ns: 'apiErrorCodes',
    defaultValue: 'Nuvarande sortering kräver inkludering av resurser.',
  }),
  'common:empty': t('common.empty', { ns: 'apiErrorCodes', defaultValue: 'Obligatoriskt fält.' }),
  'common:enum_mismatch': t('common.enumMismatch', {
    ns: 'apiErrorCodes',
    defaultValue: 'Felaktigt värde.',
  }),
  'common:format_mismatch': t('unexpectedError', { ns: 'common' }),
  'common:invalid_characters': t('common.invalidCharacters', {
    ns: 'apiErrorCodes',
    defaultValue: 'Följande tecken är inte tillåtna: ? / : \\ " < > |',
  }),
  'common:max_length_invalid': t('common.maxLengthInvalid', {
    ns: 'apiErrorCodes',
    max: '{max}',
    defaultValue: 'Antal tecken kan inte vara fler än {max}.',
  }),
  'common:min_length_invalid': t('common.minLengthInvalid', {
    ns: 'apiErrorCodes',
    min: '{min}',
    defaultValue: 'Antal tecken måste vara minst {min}.',
  }),
  'common:required_property_missing': t('unexpectedError', { ns: 'common' }),
  'common:type_mismatch': t('unexpectedError', { ns: 'common' }),
  'common:invalid_url': t('common.invalidUrl', {
    ns: 'apiErrorCodes',
    defaultValue: "Formatet på url'n är inte korrekt.",
  }),
  'common:auth_user_not_found': t('common.authUserNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Inloggad användare existerar inte.',
  }),
  'common:auth_user_account_disabled': t('common.authUserAccountDisabled', {
    ns: 'apiErrorCodes',
    defaultValue: 'Inloggad användare är inaktiverad.',
  }),
  'common:endpoint_not_found': t('common.endpointNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Anrop till server misslyckades.',
  }),
  'common:request_header_authorization_token_invalid': t(
    'common.requestHeaderAuthorizationTokenInvalid',
    { ns: 'apiErrorCodes', defaultValue: 'Anrop till server misslyckades.' },
  ),
  'common:request_header_format_invalid': t('common.requestHeaderFormatInvalid', {
    ns: 'apiErrorCodes',
    defaultValue: 'Anrop till server misslyckades.',
  }),
  'common:request_header_missing': t('common.requestHeaderMissing', {
    ns: 'apiErrorCodes',
    defaultValue: 'Anrop till server misslyckades.',
  }),
  'common:minimum_invalid': t('unexpectedError', { ns: 'common' }),
  'common:maximum_invalid': t('unexpectedError', { ns: 'common' }),
  'common:min_date_invalid': t('common.minDateInvalid', {
    ns: 'apiErrorCodes',
    expectedDate: '{expectedDate}',
    defaultValue: 'Datum måste vara {expectedDate} eller senare.',
  }),
  'common:email_address_invalid': t('common.emailAddressInvalid', {
    ns: 'apiErrorCodes',
    defaultValue: 'E-postadressen är inte giltig.',
  }),
  'common:password_num_digits_invalid': t('common.passwordNumDigitsInvalid', {
    ns: 'apiErrorCodes',
    minDigits: '{minDigits}',
    defaultValue: 'Minst antal siffror (0-9): {minDigits}',
  }),
  'common:password_num_uppercase_invalid': t('common.passwordNumUppercaseInvalid', {
    ns: 'apiErrorCodes',
    minUpperCase: '{minUpperCase}',
    defaultValue: 'Minst antal versaler (A-Z): {minUpperCase}',
  }),
  'common:password_num_lowercase_invalid': t('common.passwordNumLowercaseInvalid', {
    ns: 'apiErrorCodes',
    minLowerCase: '{minLowerCase}',
    defaultValue: 'Minst antal gemener (a-z): {minLowerCase}',
  }),
  'common:one_of': t('common.oneOf', {
    ns: 'apiErrorCodes',
    defaultValue: 'Minst antal gemener (a-z): {minLowerCase}',
  }),
  'common:one_of_or_none': t('common.oneOf', {
    ns: 'apiErrorCodes',
    defaultValue: 'Minst antal gemener (a-z): {minLowerCase}',
  }),
  'common:unauthorized_access': t('common.unauthorizedAccess', {
    ns: 'apiErrorCodes',
    defaultValue: 'Inloggad användare har inte tillgång till resursen.',
  }),
  'common:invalid_uuid': 'UUID är inte giltig.',
  'common:at_least_one_of': t('common.atLeastOneOf', {
    ns: 'apiErrorCodes',
    parameters: '{parameters}',
    defaultValue: 'Minst en av följande parametrar måste anges: {parameters}.',
  }),
});
